import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Option } from './option.interface';
import { defaultOption } from './option-helpers';

const CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    // eslint-disable-next-line
    useExisting: forwardRef(() => SelectComponent),
    multi: true
};


@Component({
  moduleId: module.id,
  selector: 'custom-select',
  templateUrl: 'select.component.html',
  providers: [CONTROL_VALUE_ACCESSOR],
})
export class SelectComponent implements ControlValueAccessor {
  defaultValue = defaultOption.option;

  @Input() name: string = '';

  @Input() selected: any = defaultOption.option;

  @Input() disabled: boolean = false;

  @Input() items: Option[] = [];

  @Input() hasError: boolean = false;

  @Input() size: string;

  @Input() formControlName: string;

  @Input() ghostValue: string;

  @Input() optionGhostValue: string;

  @Input() ngValueItem: boolean = false;

  @Output() selectedChange: EventEmitter<Option> = new EventEmitter<Option>();

  private onTouchedCallback: any;
  private onChangeCallback: any;

  writeValue(value: any): void {
    this.selected = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  onChangeSelected(selected: any) {
    this.onChangeCallback(selected);
    this.selectedChange.emit(selected);
  }

  // private
  getOptionValue(item: any) {
    return item.name || item.title;
  }

}
